export default __webpack_public_path__ + "static/people-02-tablet-2a5b4f5702aeeaa4f9ac13ad848e605a.jpg";